export default __webpack_public_path__ + "static/bg-chronicle-1-b2c7f03c214afbe262347962a3ac59e5.png";